import { render, staticRenderFns } from "./PacksList.vue?vue&type=template&id=e5e72952&scoped=true&"
import script from "./PacksList.vue?vue&type=script&lang=js&"
export * from "./PacksList.vue?vue&type=script&lang=js&"
import style0 from "./PacksList.vue?vue&type=style&index=0&id=e5e72952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e72952",
  null
  
)

export default component.exports